"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operations = void 0;
var getBalanceOperation_1 = require("./account/getBalanceOperation");
var getNFTsOperation_1 = require("./account/getNFTsOperation");
var getPortfolioOperation_1 = require("./account/getPortfolioOperation");
var getSPLOperation_1 = require("./account/getSPLOperation");
var getNFTMetadataOperation_1 = require("./nft/getNFTMetadataOperation");
var getTokenPriceOperation_1 = require("./token/getTokenPriceOperation");
exports.operations = [
    getBalanceOperation_1.getBalanceOperation,
    getNFTsOperation_1.getNFTsOperation,
    getPortfolioOperation_1.getPortfolioOperation,
    getSPLOperation_1.getSPLOperation,
    getNFTMetadataOperation_1.getNFTMetadataOperation,
    getTokenPriceOperation_1.getTokenPriceOperation,
];
//# sourceMappingURL=operations.js.map